import { render, staticRenderFns } from "./Joker.vue?vue&type=template&id=32a70e53&scoped=true&"
import script from "./Joker.vue?vue&type=script&lang=js&"
export * from "./Joker.vue?vue&type=script&lang=js&"
import style0 from "./Joker.vue?vue&type=style&index=0&id=32a70e53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a70e53",
  null
  
)

export default component.exports